
        import * as module0 from '../../src/_components/masonry.js.rb'
        const modules = {
            "masonry.js.rb": module0,
        };
        export default modules;
      